import Vue from 'vue'
import { ToastPlugin, ModalPlugin, BVConfigPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import axios from 'axios'
import AxiosPlugin from 'vue-axios-cors'
import JsonExcel from 'vue-json-excel'
import vuecookies from 'vue-cookies'
import vSelect from 'vue-select'
import VueTableDynamic from 'vue-table-dynamic'
import VTooltip from 'v-tooltip'
import VueLazyload from 'vue-lazyload'
import Select2 from 'v-select2-component'
import installMobileToastBridge from '@/libs/mobile-toast'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import 'babel-polyfill'

// BSV Plugin Registration
Vue.directive("uppercase", {
  update: el => {
      el.value = el.value.toUpperCase()
    },
})
// Every row-actions "..." dropdown across the app (b-dropdown) lives inside
// a `.table-responsive` wrapper. BootstrapVue's default `boundary` for
// b-dropdown is 'scrollParent', which is that wrapper - so Popper clips the
// menu to it and never flips it upward even when there's no room below
// (see style.scss .table-responsive comment for the matching CSS half of
// this fix). Setting the app-wide default to 'window' makes every dropdown,
// everywhere, position/flip against the browser viewport instead, so the
// menu is never cut off by the table it's rendered in.
Vue.use(BVConfigPlugin, {
  BDropdown: { boundary: 'window' },
})
Vue.use(ToastPlugin)
Vue.use(router)
Vue.use(VTooltip)
Vue.use(ModalPlugin)
Vue.use(AxiosPlugin)
// NOTE: `vue-disable-autocomplete` used to be registered here as a global
// mixin (see git history). It force-set `readonly` on every element with
// `autocomplete="off"` on mount, then only removed it inside a
// `window.addEventListener('load', ...)` callback. That `load` event has
// already fired for anything mounted after the app's initial boot (any
// modal, panel, or lazily-rendered form - e.g. the Help search box below,
// or the sidebar search input fixed earlier), so the callback never runs
// again and those inputs stay permanently readonly/unusable - can't type,
// can't search, nothing. That's a worse bug than the autofill annoyance it
// was trying to solve, and the plain `autocomplete="off"` attribute already
// on the affected inputs is enough on its own for browsers that respect it,
// so this plugin has been removed rather than patched.
Vue.use(VueLazyload)
Vue.use(VueTableDynamic)
Vue.component('Select2', Select2)
Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select-new', vSelect)
// Composition API
Vue.use(VueCompositionAPI)
Vue.use(vuecookies, { expire: '7d' })
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'

// Route toasts through a centered SweetAlert popup on mobile viewports (see
// src/libs/mobile-toast.js) — must run after the Toast and Sweetalert2
// plugins have registered `$toast` / `$swal` on Vue.prototype.
installMobileToastBridge()

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
